import { b2cConfigType } from "../types/azureB2c/azureB2cTypes";
import { PRE, PRO } from "./environmentTypes";

export function getBaseUrl(): string {

    switch (process.env.REACT_APP_ENVIRONMENT) {

        case PRE:
            return process.env.REACT_APP_BASE_URL_PRE!;

        case PRO:
            return process.env.REACT_APP_BASE_URL_PRO!;

        default:
            return process.env.REACT_APP_BASE_URL_DEV!;
    }
};



export function getApiUrl(): string {

    switch (process.env.REACT_APP_ENVIRONMENT) {

        case PRE:
            return process.env.REACT_APP_API_URL_PRE!;

        case PRO:
            return process.env.REACT_APP_API_URL_PRO!;

        default:
            return process.env.REACT_APP_API_URL_DEV!;
    }
};

export function getUnauthorizedUserUrl(): string {

    switch (process.env.REACT_APP_ENVIRONMENT) {

        case PRE:
            return process.env.REACT_APP_SOLISS_B2C_USER_NOT_AUTHORIZED_URL_PRE!;

        case PRO:
            return process.env.REACT_APP_SOLISS_B2C_USER_NOT_AUTHORIZED_URL_PRO!;

        default:
            return process.env.REACT_APP_SOLISS_B2C_USER_NOT_AUTHORIZED_URL_DEV!;
    }
};


export function getSolissB2CTokenServiceUrl(): string {

    switch (process.env.REACT_APP_ENVIRONMENT) {

        case PRE:
            return process.env.REACT_APP_SOLISS_B2C_TOKEN_URL_PRE!;

        case PRO:
            return  process.env.REACT_APP_SOLISS_B2C_TOKEN_URL_PRO!;

        default:
            return  process.env.REACT_APP_SOLISS_B2C_TOKEN_URL_DEV!;
    }
};

export function getSolissB2CRefreshTokenServiceUrl(): string {

    switch (process.env.REACT_APP_ENVIRONMENT) {

        case PRE:
            return process.env.REACT_APP_SOLISS_B2C_TOKENREFRESH_URL_PRE!;

        case PRO:
            return  process.env.REACT_APP_SOLISS_B2C_TOKENREFRESH_URL_PRO!;

        default:
            return  process.env.REACT_APP_SOLISS_B2C_TOKENREFRESH_URL_DEV!;
    }
};

export function getB2CConfiguration(): b2cConfigType {

    let b2cConfiguration: b2cConfigType = {
        clientId: '',
        authority: "https://solissonline.b2clogin.com/solissonline.onmicrosoft.com/B2C_1_SIGN_IN",
        knownAuthorities: ["solissonline.b2clogin.com"],
        redirectUri: '',
        postLogoutRedirectUri: '',
        navigateToLoginRequestUrl: true,
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
    };

    switch (process.env.REACT_APP_ENVIRONMENT) {

        case PRE:
            b2cConfiguration.clientId = process.env.REACT_APP_B2C_CLIENT_ID_PRE!;
            b2cConfiguration.redirectUri = process.env.REACT_APP_B2C_REDIRECT_URI_PRE!;
            b2cConfiguration.postLogoutRedirectUri = process.env.REACT_APP_B2C_REDIRECT_URI_PRE!;
            break;

        case PRO:
            b2cConfiguration.clientId = process.env.REACT_APP_B2C_CLIENT_ID_PRO!;
            b2cConfiguration.redirectUri = process.env.REACT_APP_B2C_REDIRECT_URI_PRO!;
            b2cConfiguration.postLogoutRedirectUri = process.env.REACT_APP_B2C_REDIRECT_URI_PRO!;
            break;

        default:
            b2cConfiguration.clientId = process.env.REACT_APP_B2C_CLIENT_ID_DEV!;
            b2cConfiguration.redirectUri = process.env.REACT_APP_B2C_REDIRECT_URI_DEV!;
            b2cConfiguration.postLogoutRedirectUri = process.env.REACT_APP_B2C_REDIRECT_URI_DEV!;
            break;
    }

    console.log('[CONFIG] redirectUri configurado:', b2cConfiguration.redirectUri);
    console.log('[CONFIG] clientId configurado:', b2cConfiguration.clientId);

    return b2cConfiguration;
};